export class VisitorFormDto {
  firstName: string;
  lastName: string;
  company: string;
  reasonForVisiting: string;
  idDetails: string;
  contactPerson: string;
  cardAccess: string;
  entryHour: Date;
  exitHour: Date;
  stayUntilDayEnd: boolean;
  signature: string;
}
